import Operator from "./Operator";


let GreaterOrEqual = Operator.extend("GreaterOrEqual", {
    literal: [">="],

    validateValue(value) {
        return this.validateLiteral(value);
    },

    compile2js(left, right) {
        if ( right == null ) {
            return "false";
        }

        right = JSON.stringify(right);
        return left + " != null && " + right + " != null && +" + left + " >= +" + right;
    }
});

export default GreaterOrEqual;
